<template lang='pug'>
    v-tooltip( top )
        template( slot='activator' )
            a.secondary--text( @click='submit' )
                slot
        span {{ tooltip }}
</template>

<script>
    //
    export default {
        computed: {

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            route() {
                return this.mapper(this.value)
            },
        },
        methods: {

            /**
             * { function_description }
             */
            submit() {
                this.$router.push(this.route)
            },
        },
        props: {

            /**
             * { item_description }
             */
            mapper: {
                type: Function,
                default: value => `/${value}`,
            },

            /**
             * { item_description }
             */
            tooltip: {
                type: String,
                default: '',
            },

            /**
             * { item_description }
             */
            value: {
                type: [Number, Object, String],
                default: '',
            }
        },
    }
</script>

<style>
    a.secondary--text:hover {
        text-decoration: underline;
    }
</style>